import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Link,
  Stack,
  Typography
} from "@mui/material";
import { Button } from "components/UI";
import { memo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const StructureFormFooter = memo(({ control, errors, isLoading, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center">
      <FormControlLabel
        control={
          <Controller
            name="acceptTerms"
            control={control}
            render={({ field }) => (
              <Checkbox
                {...field}
                checked={field.value}
                onChange={e => field.onChange(e.target.checked)}
                color="primary"
              />
            )}
          />
        }
        label={
          <Typography variant="body1">
            {t("denominations.createDenomination.agree")}{" "}
            <Link href="#" color="inherit">
              {t("denominations.createDenomination.termsAndConditions")}
            </Link>
          </Typography>
        }
      />
      {!!errors.acceptTerms?.message && (
        <FormHelperText error>{errors.acceptTerms?.message}</FormHelperText>
      )}

      <Button
        type="submit"
        size="large"
        variant="contained"
        sx={{ mt: 3 }}
        disabled={isLoading}
        onClick={onSubmit}
      >
        {t("denominations.structures.createStructure")}
      </Button>
    </Stack>
  );
});

StructureFormFooter.displayName = "StructureFormFooter";

export default StructureFormFooter;
